<!-- THIS IS SHARED BETWEEN PORTAL AND APP-->
<template>
    <div style="display: flex; align-items: flex-end">
        <div v-for="(item, index) in protocolItems" :key="index">
            <v-tooltip location="top">
                <template v-slot:activator="{ props }">
                    <!-- render the colored dots -->
                    <div v-if="measureAverageList && !allMeasuresFromConstants[item.regulationMeasureId].isNotBaselineable"
                         class="session-dot"
                         :style="{'background-color': measureAverageList[item.regulationMeasureId] ? getCiColor(measureAverageList[item.regulationMeasureId].variabilityType) : '#eeeeee'}"
                         v-bind="props"
                    />
                </template>
                <span>{{ getTestTypeName(item.regulationMeasureId) }}</span>
            </v-tooltip>
        </div>
    </div>
</template>


<script>
import AppCard from "@/components/AppCard";
import {getCiColor} from "@/js/shared/helper";
import AppButton from "@/components/AppButton";
import {allMeasuresFromConstants} from "@/js/shared/constants";

export default {
    name: "SessionDots",
    components: {AppButton, AppCard},
    props: {
        protocolItems: {
            required: true
        },
        measureAverageList: {
            required: true
        }
    },
    data() {
        return {
            allMeasuresFromConstants
        }
    },
    methods: {
        getCiColor(variabilityType) {
            return getCiColor(variabilityType)
        },
        getTestTypeName(key) {
            return allMeasuresFromConstants[key]?.label ? allMeasuresFromConstants[key]?.label : '-'
        },
    }
}
</script>

<style scoped>

</style>